export default __webpack_public_path__ + "static/realWorldImg1-32720ebd37a6af2f046fa98a22ba5d5d.png";